// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2US8V","text":"SelectPayment_text__2XIty","title":"SelectPayment_title__FGwL1","btn":"SelectPayment_btn__3fo3v"};